
import React, { useState, useEffect, useRef } from 'react';
import { useQuery, useQueryClient } from 'react-query'
import { getAlerts } from 'data/Querys';
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { getSportCodeObject } from "components/common/SportCode";



function Ticker() {
    const ref = useRef(null);
    const { mirs_language, mirs_competition, mirs_discipline } = useUrlFriendlyToParameters();
    const [Msg, setMsg] = useState("");
    const [dataSportCodes, setDataSportCodes] = useState()
    const queryClient = useQueryClient();

    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['messages_alerts', mirs_competition, mirs_discipline, "RESULTS"],
            queryFn: getAlerts,
            refetchInterval: 60000,
        }
    );

    useEffect(() => {
        if (!Msg) {
            dataTicker()
        }
    }, [data]);

    useEffect(() => {
        window.scrollTo(0, 0)
        setDataSportCodes(queryClient.getQueryData(["SportCodes", mirs_competition, mirs_language])?.sportCodes);
    }, [])


    function updateTicker(ev) {
        if (ev.animationName === 'ticker') {
            dataTicker()
        }
    }

    function dataTicker() {
        const alertElement = data?.alert?.find(x => x !== undefined)
        if (alertElement?.alertCode && alertElement?.alertCode !== 'OTHR') {
            let msg = getSportCodeObject(dataSportCodes, mirs_discipline, '@Alert', alertElement?.alertCode)?.description
            setMsg(msg)
        } else {
            setMsg(alertElement?.message)
        }
    }


    if (isError) { return (''); }
    //if (isLoading) { return (''); }
    //if (!data) { return (<div className='container'><NotAvailable /></div>); }


    return (
        <>
            <div className={`ticker-wrap  ${Msg ? "" : "invisible "}`} >
                <div className={`${Msg ? "ticker" : ""}`} onAnimationIteration={(ev) => {
                    ev.preventDefault();
                    updateTicker(ev);
                }}>
                    <div className='ticker__item'>
                        {Msg}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Ticker;





